import { IonHeader } from '@ionic/react';
import React from 'react';
import './Navbar.css';
import NavbarComponent from './menus/navbar';
import FlexMobileNotShow from './menus/flex/flexMobileNotShow';
import MobileNavbar from './menus/mobileNavbar';

const MyHeader: React.FC = () => {
  return (
      <IonHeader className="ion-no-border">
        <FlexMobileNotShow minWidth={1024}>
          <NavbarComponent />
        </FlexMobileNotShow>
        <FlexMobileNotShow maxWidth={1024} style={{width: '100%', backgroundColor: '#3880ff'}} >
          <MobileNavbar />
        </FlexMobileNotShow>
      </IonHeader>
  );
};

export default MyHeader;